import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule, Routes } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { AppDialogModule } from '../dialog';
import { TemplateCardComponent } from '../template-card/template-card.component';
import { ManageTemplatesComponent } from './manage-templates.component';
import { ManageTemplatesService } from './manage-templates.service';
import { NoTemplatesComponent } from './no-templates/no-templates.component';

const routes: Routes = [
  {
    path: '',
    component: ManageTemplatesComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    RouterModule.forChild(routes),
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    TemplateCardComponent,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    AppDialogModule,
    GalaxyPageModule,
    MatIconModule,
    MatButtonModule,
  ],
  declarations: [ManageTemplatesComponent, NoTemplatesComponent],
  exports: [RouterModule],
  providers: [ManageTemplatesService],
})
export class ManageTemplatesModule {}
